import { useStructureContext } from "../../../context/StructureContext";
import { stdObject } from "../../../data/types/stdObject";
import StdTable from "./StdTable";
import { useMainContext } from "../../../context/MainContext";
import { brandsHeaders } from "../../../data/warehouse";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

export default function BrandsBox() {
  const brandsList: stdObject[] = useSelector(
    (state: RootState) => state.data.brands,
  );
  const { type } = useStructureContext();
  const { handleMainData } = useMainContext();

  return (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={brandsHeaders}
        data={brandsList}
        onDoubleClick={(data, index) => handleMainData(data, index, false)}
        className="listTableRow"
      />
    </div>
  );
}
